"use strict";

module.exports = {
  Store: "store",
  StateSource: "state source",
  ActionCreators: "action creators"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/utils/humanStrings.js
 ** module id = 509
 ** module chunks = 0
 **/